import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '../Footer';
import Header from '../Header';
import Warning from '../../assets/icon/Warning.svg';
import FileDownload from '../../assets/icon/FileDownload.svg';
import Proceed from '../../assets/icon/Proceed.svg';
import CandidateEnv from '../../assets/icon/CandidateEnv.svg';
import {
  DOWNLOAD_BROWSER_TEXT,
  DOWNLOAD_LINK_TEXT,
  getAppDownloadLink,
  INSTRUCTION_TEXT,
  INSTRUCTION_TEXT_SUB_PARTS,
  PROCEED_TEST_TEXT,
  UBA_EVENT_NAME,
} from '../../util/constant';
import './instruction.scss';
import LoaderComponent from '../Loader';
import {
  encodeAccessCodeInUrl,
  getOSinfo,
  removeCharsByVowelCount,
} from '../../util/helper';
import { initTracking, proctoringUBALogger } from '../../util/trackingUtils';
import SystemInfoModal from './Modal/SystemInfoModal';

const Instruction = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [subsytemInfo, setSubsytemInfo] = useState({
    show: false,
    info: '',
  });
  const location = useLocation();
  // Extract query parameters from the location object
  const queryParams = new URLSearchParams(location.search);
  // Get the value of a specific query parameter
  const testUrl = encodeAccessCodeInUrl(queryParams.get('dsUrl'));
  const testName = queryParams.get('testName');
  const candidateEmail = queryParams.get('email');

  useEffect(() => {
    const ubaPayload = {
      pageName: 'Instruction Page',
    };
    const keyNames = {
      loggedinUserEmailId: candidateEmail,
      testName,
    };

    initTracking(ubaPayload, keyNames);
  }, []);
  const { osType, deviceType } = getOSinfo();

  const metadata = encodeURIComponent(queryParams.get('metadata') || '');

  function decryptUrl(encryptedUrl) {
    const decrypted = removeCharsByVowelCount(encryptedUrl, candidateEmail);
    return decrypted;
  }

  useEffect(() => {
    if (osType === 'Linux') {
      setSubsytemInfo((prev) => ({
        ...prev,
        show: true,
      }));
    }
    if (deviceType !== 'Desktop') {
      setIsMobile(true);
      setIsLoading(false);
    } else if (
      osType !== 'Windows' &&
      osType !== 'Linux' &&
      osType !== 'MacOS'
    ) {
      const decryptedUrl = decryptUrl(`${testUrl} + &metadata=${metadata}`);
      proctoringUBALogger(
        UBA_EVENT_NAME.LOG_INFO_EVENT,
        `${decryptedUrl}- normal assessment flow`
      );
      window.open(decryptedUrl);
    } else {
      setIsLoading(false);
      proctoringUBALogger(
        UBA_EVENT_NAME.LOG_INFO_EVENT,
        `${testUrl}-secure browser assessment flow`
      );
    }
  }, []);

  useEffect(() => {
    proctoringUBALogger('LINUX_SUB_TYPE', subsytemInfo.info);
    if (subsytemInfo.info === 'NonDebian_based') {
      const decryptedUrl = decryptUrl(`${testUrl} + &metadata=${metadata}`);
      window.open(decryptedUrl);
    }
  }, [subsytemInfo]);

  return (
    <div
      className={`instruction-container ${isMobile ? 'mobile-container' : ''}`}
    >
      <Header isMobile={isMobile} />
      {isLoading && (
        <div className="loader-container">
          <LoaderComponent title="" subText="Checking Device Compatibility" />
        </div>
      )}
      {isMobile && !isLoading && (
        <div className="mobile-block-message">
          <div className="mobile-error-container">
            <img src={Warning} alt="warning" />
            <h2>Unsupported Device</h2>
            <p>
              This assessment can only be taken on a desktop or laptop device.
              Please switch to a compatible system and try again.
            </p>
          </div>
        </div>
      )}
      {!isLoading && !isMobile && (
        <>
          {subsytemInfo?.show ? (
            <SystemInfoModal setSubsytemInfo={setSubsytemInfo} />
          ) : (
            <div className="instruction-body">
              <div className="instruction-header">
                <img src={CandidateEnv} alt="candidateEnv" />
                <div className="title-conatiner">
                  <p>Please Note:</p>
                  <p>
                    This session needs
                    <span className="link-text">
                      {' '}
                      Doselect Secure Browser{' '}
                    </span>{' '}
                    to be downloaded and installed.
                  </p>
                </div>
              </div>
              <div className="candidate-instruction">
                <div className="title">
                  <img src={Warning} alt="Warning" />
                  <span className="instruction-text">{INSTRUCTION_TEXT}</span>
                  <ul>
                    {INSTRUCTION_TEXT_SUB_PARTS.map((instruction, index) => (
                      <li key={index}>{instruction}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="horizontal-line" />
              <div className="download-link-container">
                <div className="title">{DOWNLOAD_LINK_TEXT}</div>
                <div className="links-container">
                  <button
                    type="button"
                    className="test-link primary"
                    onClick={() => {
                      proctoringUBALogger(
                        'Start secure browser assessment',
                        `Doselect://?email=${candidateEmail}&testName=${testName}&dsUrl=${testUrl}&metadata=${metadata}`
                      );
                      window.open(
                        `Doselect://?email=${candidateEmail}&testName=${testName}&dsUrl=${testUrl}&metadata=${metadata}`
                      );
                    }}
                  >
                    {PROCEED_TEST_TEXT}
                    <img src={Proceed} alt="proceed" />
                  </button>
                  <button
                    type="button"
                    className="download secondary"
                    onClick={() => {
                      proctoringUBALogger(
                        'Download secure browser',
                        getAppDownloadLink(osType)
                      );
                      window.open(getAppDownloadLink(osType));
                    }}
                  >
                    {DOWNLOAD_BROWSER_TEXT}
                    <img src={FileDownload} alt="download" />
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <Footer isMobile={isMobile} />
    </div>
  );
};

export default Instruction;
